/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Diagnosis
 */
export interface Diagnosis {
    /**
     * 
     * @type {string}
     * @memberof Diagnosis
     */
    icd10_code: string;
    /**
     * 
     * @type {string}
     * @memberof Diagnosis
     */
    onset_or_exacerbation: string;
    /**
     * 
     * @type {string}
     * @memberof Diagnosis
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof Diagnosis
     */
    symptom_control_rating?: string;
}

/**
 * Check if a given object implements the Diagnosis interface.
 */
export function instanceOfDiagnosis(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "icd10_code" in value;
    isInstance = isInstance && "onset_or_exacerbation" in value;
    isInstance = isInstance && "date" in value;

    return isInstance;
}

export function DiagnosisFromJSON(json: any): Diagnosis {
    return DiagnosisFromJSONTyped(json, false);
}

export function DiagnosisFromJSONTyped(json: any, ignoreDiscriminator: boolean): Diagnosis {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'icd10_code': json['icd10_code'],
        'onset_or_exacerbation': json['onset_or_exacerbation'],
        'date': json['date'],
        'symptom_control_rating': !exists(json, 'symptom_control_rating') ? undefined : json['symptom_control_rating'],
    };
}

export function DiagnosisToJSON(value?: Diagnosis | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'icd10_code': value.icd10_code,
        'onset_or_exacerbation': value.onset_or_exacerbation,
        'date': value.date,
        'symptom_control_rating': value.symptom_control_rating,
    };
}

